import React, { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import PreguntasFrecuentesPcr from "../PreguntasFrecuentesPcr/PreguntasFrecuentesPcr";
import "./ModalPreguntas.css"

const ModalPreguntas = ({ titulo, dissmiss }) => {
  const { preguntasFrecuentesState } =
    useContext(PortalContext);


  return (
    <React.Fragment>
      <div className="ptur-modalPortalExt-header">
        <span className="rb18m">{titulo}</span>
        <div className="ptur-modalPortalExt-cruz" onClick={dissmiss}>
          <div className="ptur-modalPortalExt-cruzParte1"></div>
          <div className="ptur-modalPortalExt-cruzParte2"></div>
        </div>
      </div>
      <div className="ptur-modalPortalExt-body">
        {Array.isArray(preguntasFrecuentesState.preguntasFrecuentes.data) &&
          preguntasFrecuentesState.preguntasFrecuentes.data.map(
            (item, index) => {
              return (
                <PreguntasFrecuentesPcr
                  key={index}
                  pregunta={item.pregunta}
                  respuesta={item.respuesta}
                />
              );
            }
          )}
      </div>
    </React.Fragment>
  );
};

export default ModalPreguntas;
